// Copyright 2026 FlairCV Contributors
// SPDX-License-Identifier: AGPL-3.0-or-later

import { z } from 'zod';

/** Schema for creating/editing a work experience. */
export const experienceSchema = z.object({
  job_title: z
    .string()
    .min(1, 'Job title is required.')
    .max(255, 'Job title must be at most 255 characters.'),
  company_name: z
    .string()
    .min(1, 'Company name is required.')
    .max(255, 'Company name must be at most 255 characters.'),
  location: z
    .string()
    .max(255, 'Location must be at most 255 characters.')
    .optional()
    .or(z.literal('')),
  start_date: z.string().min(1, 'Start date is required.'),
  end_date: z.string().optional().or(z.literal('')),
  description: z
    .string()
    .max(10000, 'Description must be at most 10,000 characters.')
    .optional()
    .or(z.literal('')),
});

export type ExperienceFormData = z.infer<typeof experienceSchema>;
